import React from 'react';
import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from './AuthContext';

const RoleProtectedRoute = ({ allowedRoles, children }) => {
  const { isLoggedIn, role } = useContext(AuthContext);

  if (!isLoggedIn || !allowedRoles.includes(role)) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default RoleProtectedRoute;